import { CRM as CRMComponent } from "../design-system/components/crm/CRM";


export default function CRM(){

 return (
   <CRMComponent />
 );

}